import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function PaymeCardBridge({ status = "return" }) {
  const { search } = useLocation();

  useEffect(() => {
    const params = new URLSearchParams(search);
    const setupId = params.get("setup_id");
    try {
      window.parent.postMessage(
        JSON.stringify({ type: status === "cancel" ? "payme_card_cancel" : "payme_card_return", setup_id: setupId }),
        window.location.origin
      );
    } catch (e) {}
  }, [search, status]);

  return (
    <div dir="rtl" style={{ padding: 24, fontFamily: "Heebo, Assistant, Arial", textAlign: "center" }}>
      {status === "cancel" ? "שמירת הכרטיס בוטלה" : "שמירת הכרטיס נקלטה, מעדכנים את הפרטים..."}
    </div>
  );
}
